<!--
 * @Description:审核记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-10-24 10:29:31
 * @LastEditors: cxh
-->
<template>
  <a-form scrollToFirstError>
    <dc-layout-card :title="props.title" :span="24">
      <a-col>
        <cos-table
          tableId="DcCosFbuApplyRecord"
          :needPage="false"
          serial
          :columns="columns"
          @fetch="fetch"
          ref="table"
        >
        </cos-table>
      </a-col>
    </dc-layout-card>
  </a-form>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { cluerApplyecord } from '@/api/gucangSales/clueManage'
import { useRoute } from 'vue-router'
const route = useRoute()
const props = defineProps({
  returnName: {
    type: String
  },
  title: String
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.recordId) {
    cluerApplyecord({
      recordId: route.query.recordId
    }).then((res) => {
      // 处理数据
      const state: any = {
        1: '待审批',
        2: '已通过',
        3: '已驳回'
      }
      const result = []
      result.push({
        checkTime: res.data.applyTime,
        checkUser: res.data.createByName,
        checkNode: '申请',
        content: `申请原因：${res.data.applyReason}`
      })
      // 审批
      result.push({
        checkTime: res.data.auditTime,
        checkUser: res.data.auditorName,
        checkNode: '审批',
        content: state[res.data.auditStatus] + `${res.data.opinion ? '【' + res.data.opinion + '】' : ''}`
      })
      // 拼申请人
      callBack({
        data: result
      })
    })
  }
}
const columns = ref([
  {
    title: '操作时间',
    dataIndex: 'checkTime'
  },
  {
    title: '操作人',
    dataIndex: 'checkUser'
  },
  {
    title: '节点',
    dataIndex: 'checkNode'
  },
  {
    title: '内容',
    dataIndex: 'content'
  }
])
</script>
<script lang="ts">
export default {
  name: 'TabsOperationLog'
}
</script>
<style lang="scss" scoped></style>
